import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  IconButton,
} from "@mui/material";
import Iconify from "../components/iconify";
import {
  getBlobsInContainer,
  createBlobInContainer,
  deleteBlobIfItExists,
} from "src/utils/filesApi";

export default function HeadshotsPage() {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState(null);
  const [prefix, setPrefix] = useState("");
  const { id } = useParams();

  const getContainerImages = async () => {
    const data = await getBlobsInContainer(prefix);
    setImages(data);
  };
  const fetchImages = async () => {
    await getContainerImages();
  };
  const deleteImageHandler = async (value) => {
    await deleteBlobIfItExists(value);
    window.location.reload(false);
  };
  
  const uploadFiles = (event) => {
    if (event.target.files.length > 0) {
      setLoading(true);
      const files = event.target.files;
      let uploadPromises = [];
      for (let i = 0; i < files.length; i++) {
        uploadPromises.push(createBlobInContainer(files[i], prefix));
      }
      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          await Promise.all(uploadPromises);
          await getContainerImages();
          setLoading(false);
        };
        uploadFiles().catch(console.error);
      }
    }
  };

  useEffect(() => {
    setPrefix(`${id}/`);
  }, [id]);

  useEffect(() => {
    if (prefix) fetchImages().catch(console.error);
  }, [prefix]);

  return (
    <>
      <Helmet>
        <title> Headshots </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Headshots
          </Typography>
          <Button
            variant="contained"
            component="label"
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            Upload Files
            <input
              hidden
              accept="image/*"
              multiple
              type="file"
              onChange={uploadFiles}
            />
          </Button>
        </Stack>
        <Card sx={{ p: 2 }}>
          {images === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <ImageList cols={4} rowHeight={164}>
              {images.map((item, index) => (
                <ImageListItem key={index}>
                  <img
                    src={item.blobUrl}
                    srcSet={item.blobUrl}
                    alt="library"
                    loading="lazy"
                  />
                  <ImageListItemBar
                    title={item.blobName}
                    subtitle={""}
                    actionIcon={
                      <IconButton
                        sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                        aria-label={`info about ${item.title}`}
                        value={item.blobName}
                        onClick={() => {
                          deleteImageHandler(item.blobName);
                        }}
                      >
                        <Iconify icon="eva:trash-2-outline" />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </Card>
      </Container>
    </>
  );
}
